// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';

// Vue Components
import pdpContainer from '@/components/containers/pdp/PdpContainer.vue';
import TabsContentContainer from '@/components/tabs/TabsContentContainer';
import buyZoneContainer from '@/components/containers/buy-zone/BuyZoneContainer.vue';
import productCardItem from '@/components/containers/plp/ProductCardItem';
import bulkProductGridContainer from '@/components/containers/bulk-product/BulkProductGridContainer';
import techInfoContainer from '@/components/containers/tech-info/TechInfoContainer.vue';
import {PdlTogglSwitch} from '@pedal/pdl-toggle-switch';
import {PdlLoading} from '@pedal/pdl-loading';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import ProductReviewsWriteReviewComponent from '@/components/power-reviews/ProductReviewsWriteReviewComponent';
import ProductReviewsComponent from '@/components/power-reviews/ProductReviewsComponent';
import ProductReviewsHeader from '@/components/power-reviews/ProductReviewsHeader';
import SizeTable from '@/components/SizeTable';
import GeometryContainer from '@/components/containers/pdp/GeometryContainer';
import ProductReferencesContainer from '@/components/containers/product-references/ProductReferencesContainer';
import {PdlCollapse, PdlCollapseItem} from '@pedal/pdl-collapse';
import {BikeOverviewContainer, AftermarketOverviewContainer} from '@/components/containers/pdp/overview';
import {PdlCallout} from '@pedal/pdl-callout';
import SpecsContainer from '@/components/tabs/specs/SpecsContainer.vue';
import BomSpecsContainer from '@/components/tabs/specs/BomSpecsContainer.vue';
import ProductPrimaryFeatures from '@/components/tabs/features/ProductPrimaryFeatures.vue';
import ProductStories from '@/components/tabs/overview/ProductStories.vue';
import ProductMediaReviewComponent from '@/components/tabs/overview/ProductMediaReviewComponent.vue';

// Legacy Plugins
import '@/vendor/owl.carousel.min.js';
import '@/vendor/owl.carousel.plugins.js';
import '@/vendor/jquery.magnific-popup.min';

// Legacy Modules
import slider from '@/modules/slider';
import player from '@/modules/Players';

// Styling
import '@sassRoot/entryPoints/b2c/pdp.scss';
class Pdp extends Shell {
  loadPlugins() {
    // Load common plugins from Shell
    super.loadPlugins();
  }

  preLoadInits() {
    super.preLoadInits();
  }
}

const pdp = new Pdp({
  pdpContainer,
  buyZoneContainer,
  TabsContentContainer,
  productCardItem,
  bulkProductGridContainer,
  techInfoContainer,
  PdlTogglSwitch,
  PdlLoading,
  GeometryContainer,
  SizeTable,
  TrekButton,
  TrekLink,
  ProductReviewsWriteReviewComponent,
  ProductReviewsComponent,
  ProductReviewsHeader,
  PdlCollapse,
  PdlCollapseItem,
  ProductReferencesContainer,
  BikeOverviewContainer,
  AftermarketOverviewContainer,
  SpecsContainer,
  BomSpecsContainer,
  PdlCallout,
  ProductPrimaryFeatures,
  ProductStories,
  ProductMediaReviewComponent,
});
pdp.preLoadInits();
pdp.initializeVue();

$(window).on('load', () => {
  pdp.globalDocumentReadyInits();

  // PDP Sliders
  const sliders = $('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });

  // PDP Videos
  player();
});

$(window).on('load', () => {
  pdp.globalOnLoadInits();
});
